import { OrderFragment } from '@graphql/fragments';
import { useCustomerIdToken } from '@hooks/customer';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { Order, OrderData } from '@repo/ui/src/types/order';
import {
  DefaultVariables,
  GraphQLRequestWithTokenProps,
  requestWithToken,
} from '@utils/graphql-request';
import { gql } from 'graphql-request';
import { SWRConfiguration } from 'swr';
import useSWRImmutable from 'swr/immutable';
import { formatOrder } from '@hooks/order/helpers';

export const customerOrder = gql`
  ${OrderFragment}

  query CustomerOrder($order: String!) {
    order(orderNumber: $order) {
      ...Order
    }
  }
`;

interface Variables extends DefaultVariables {
  order: string | null;
}
const fetcher = async (props: GraphQLRequestWithTokenProps<Variables>) => {
  if (!props.variables?.order) {
    return undefined;
  }
  const data = await requestWithToken<{ order: OrderData | null }>(props);
  return data?.order ? formatOrder(data.order) : undefined;
};

export const useCustomerOrder = (variables: Variables, config: SWRConfiguration = {}) => {
  const { locale } = useCurrentUrl();
  const idToken = useCustomerIdToken();
  return useSWRImmutable<Order | undefined>(
    {
      document: customerOrder,
      variables: variables,
      idToken,
      locale,
    },
    fetcher,
    config,
  );
};
